module.exports = require("lodash/isFunction");


//////////////////
// WEBPACK FOOTER
// external "lodash/isFunction"
// module id = 14
// module chunks = 0